import { DataShedule, ResponseSheduleImportFcl } from '@/types/scheduleImport';
import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

export const getScheduleImportFcl = async (): Promise<DataShedule[]> => {
  try {
    const res = await apiClient.post<ResponseSheduleImportFcl>(
      Endpoints.ImportFCLSchedule,
      {}
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
